import { StyledModalText, UIButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { removeInviteMapSharing } from "domains/createShareSettings/actions";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";
import { topicSlice } from "domains/topic/topic.slice";

export const ConfirmRemoveCollaboratorModal = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { email, topicId } = useSelector(getModalParams) as ModalParams<"ConfirmRemoveCollaborator">;
  const translate = useTranslate();

  const handleCloseClick = () => dispatch(deactivateModal());

  const handleRemoveClick = () => {
    if (!topicId || !email) {
      return;
    }
    dispatch(removeInviteMapSharing({ topic_id: topicId, email, removeMap: true }));
    dispatch(topicSlice.actions.decrementCustomTopicsCount());
    dispatch(deactivateModal());
    go("/create");
  };

  return (
    <>
      <ModalHeader title={translate("app.create.map_share.confirm_remove_user.title")} />
      <StyledModalText>{translate("app.create.map_share.confirm_remove_user")}</StyledModalText>
      <UIButton onClick={handleRemoveClick} error>
        {translate("app.topic.actions.delete")}
      </UIButton>
      <UIButton variant="outlined" onClick={handleCloseClick}>
        {translate("app.create.create_map.cancel")}
      </UIButton>
    </>
  );
};
